import { EllipsisHorizontalIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import Dropdown from '../tailwind/dropdown'

const OptionsDropdown = ({
  menuButtonSize = 'size-7',
  menuButtonIconSize = 'size-5',
  options = []
}) => {
  return (
    <Dropdown
      MenuButtonX={() => (
        <div
          className={clsx(
            'group flex cursor-pointer items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200',
            menuButtonSize
          )}
        >
          <EllipsisHorizontalIcon
            className={clsx(
              'text-gray-700 group-hover:text-gray-900',
              menuButtonIconSize
            )}
          />
        </div>
      )}
      actions={options}
    />
  )
}

OptionsDropdown.propTypes = {
  menuButtonSize: PropTypes.string,
  menuButtonIconSize: PropTypes.string,
  options: PropTypes.array
}

export default OptionsDropdown
